<div class="section">
  <div class="page-title">
    <div class="title">
      <div class="title-inner">
        <qds-title data-layer="main" data-level="section" data-icon="false" data-kicker="false" data-subtitle="false"
          icon="false" class="title-text">My Devices</qds-title>

        <div class="view-tabs">
          <qds-icon class="qds-icon view-tab-btn" title="Card View" size="standard" name="window-dock-panel"
            [ngClass]="{'active': selectedView === 'dock'}" [state]="selectedView === 'dock' ? 'pressed' : 'default'"
            (click)="setView('dock')"> </qds-icon>
          <qds-icon class="qds-icon view-tab-btn" title="Table View" size="standard"
            [ngClass]="{'active': selectedView === 'table'}" [state]="selectedView === 'table' ? 'pressed' : 'default'"
            name="table" (click)="setView('table')"> </qds-icon>
          <qds-icon class="qds-icon view-tab-btn" title="Map View" [ngClass]="{'active': selectedView === 'map'}"
            [state]="selectedView === 'map' ? 'pressed' : 'default'" name="location-pin" (click)="setView('map')">
          </qds-icon>
        </div>

      </div>
    </div>
  </div>
  <div class="search-filter">
    <div class="search-bar">
      <qds-input type="search" (qdsInput)="searchAll($event.target.value)" placeholder="Search" class="txtSearch"
        size="standard" state="default" focus="false" style="width: 100%;"></qds-input>
    </div>
    <div class="filter" *ngIf="selectedView === 'map' && !noDeviceFound">
      <qds-chip *ngFor="let deviceType of deviceFilterArray" 
        [text]="deviceType" 
        [ngClass]="{'selected': selectedDeviceTypes.includes(deviceType)}"
        (click)="filterByDeviceType(deviceType)">
      </qds-chip>
    </div>
  </div>
  

  <div class="qds-controls qds-related" *ngIf="isLoading" style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; width: 100%; min-height: 300px; gap: 24px;">
    <!-- Device List Skeleton -->

    <div class="device-list-skeleton" style="width: 28%; min-width: 320px; max-width: 420px;">
      <div *ngFor="let n of [1,2,3,4,5]" style="margin-bottom: 16px;">
        <div class="device-list-skeleton"></div>
      </div>
    </div>
    <!-- Map Skeleton -->
    <div class="map-skeleton">
      <qds-loader size="jumbo"></qds-loader>
    </div>
  </div>

  <div class="no-device-found" *ngIf="!isLoading && noDeviceFound">
    <!-- <qds-icon name="breaker" size="jumbo" class="qds-icon"></qds-icon> -->
    <img src="assets/nosearch.png" height="30px" width="30px" />
    <span class="noDeviceFound">{{labels.noDeviceFound || 'No device found'}}</span>
  </div>
  

  <div class="mydevice-container" *ngIf="!isLoading && !noDeviceFound">
    <ng-container *ngIf="selectedView === 'map'">
      
      <div class="device-list" >
        <p-accordion [activeIndex]="0" width="100%">
          <p-accordionTab *ngFor="let group of groupedByDeviceGroups" expandIcon="pi pi-plus"
            collapseIcon="pi pi-minus">
            <ng-template pTemplate="header">
              <div class="accordion-header-container">
                <div class="accordion-header-content">
                  <div class="accordion-header-title">
                    {{group.groupName}}
                  </div>
                </div>
              </div>
              <div class="accordion-header-divider">
              </div>
            </ng-template>
            <div *ngFor="let item of group.items; trackBy:id" style="padding-bottom: 5px;">
              <div class="map-view-header" 
                (mouseenter)="GetCoolerLocation(item.latitude,item.longitude, item.name , item )">
                <div [ngClass]="{'CriticalAlarmBorder':item.alarm_Severity==1, 'warningAlarmBorder':item.alarm_Severity==2}" class="map-tooltip-card"
                  style="position: relative;">
                  <app-device-context-menu [item]="item" [role]="role" [isVisible]="isDeviceInfoVisible === item"
                    (toggle)="showDeviceInfo($event)" (shareDevice)="onShareDevice($event)" (remoteLinkUpdated)="GetDeviceData()">
                  </app-device-context-menu>

                  <div class="map-tooltip-inner">
                    <div class="map-tooltip-image-col" >
                      <ng-container *ngIf="item.coolerImage; else defaultImages">
                        <img class="map-tooltip-img1" [src]="item.coolerImage" />
                        <img class="map-tooltip-img2" src="assets/AIR Edge 1.png" />
                      </ng-container>
                      <ng-template #defaultImages>
                        <img class="map-tooltip-img1" *ngIf="item?.deviceType === 'REX'" src="assets/eliwell_product_images/Refrigeration Expert XP 3D 2.png" />
                      </ng-template>
                      <!-- <img class="map-tooltip-img2" *ngIf="item?.deviceType === 'REX'" src="assets/eliwell_product_images/Refrigeration Expert XP 3D 2.png" /> -->
                    </div>

                    <div class="map-tooltip-details">
                      <div class="map-tooltip-row">
                        <div class="map-tooltip-section">
                          <div class="map-tooltip-labels">
                            <div class="map-tooltip-label">Edge Device</div>
                            <div class="map-tooltip-value" [ngClass]="{'map-tooltip-link': item.deviceType !== 'REX'}">

                              <span *ngIf="editingItemId !== item.id && !(role === roles.enduser && item.remoteLink)"> {{item.name}}  </span> 

                              <a class="hlink cursor-pointer" *ngIf="item.remoteLink && role === roles.enduser" (click)="navigateToRemoteLink(item.remoteLink)" (keypress)="navigateToRemoteLink(item.remoteLink)" (keydown)="navigateToRemoteLink(item.remoteLink)" (keyup)="navigateToRemoteLink(item.remoteLink)" >
                                <span>{{item.name}}</span>
                              </a>
                              <!-- <a *ngIf="editingItemId !== item.id"> {{item.name}}  </a> -->
                              <span *ngIf="editingItemId === item.id" class="editDeviceName">
                                <qds-input #editDeviceInput type="text" name="value" autofocus maxlength="29" [value]="pendingDeviceName"
                                  (qdsInput)="pendingDeviceName = $event.target.value"
                                  (keydown.Enter)="updateDeviceName()" (keydown.Meta.Enter)="updateDeviceName()"
                                  (keydown.Escape)="cancelEdit()" (focusout)="updateDeviceName()" qdsFoucus size="standard">
                                </qds-input>
                                <qds-loader *ngIf="isEditLoader" size="small"></qds-loader>
                              </span>
                            </div>
                            <div class="map-tooltip-subtitle">{{item.dongleUId}}</div>
                          </div>
                          <div *ngIf="item.deviceType === 'AIREdge' && (role === roles.enduser || role === roles.installer)">
                            <!-- <qds-button size="small" importance="subdued" text="false" state="default" class="toolbar_icon" icon-name="pencil"></qds-button> -->
                            <qds-icon *ngIf="editingItemId !== item.id" name="pencil" icon-library="default" class="qds-icon"
                              (click)="edit(item, item.id, item.name)" title="Edit">
                            </qds-icon>
                          </div>
                        </div>
                        <div class="map-tooltip-empty"></div>
                        <div class="map-tooltip-section">
                          <div class="map-tooltip-labels">
                            <div class="map-tooltip-label">Device Model</div>
                            <div class="map-tooltip-value">{{item.controllerTypeName}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="map-tooltip-row">
                        <div class="map-tooltip-section">
                          <div class="map-tooltip-labels">
                            <div class="map-tooltip-label alt">Edge Model</div>
                            <div class="map-tooltip-value alt">{{item.deviceType}}</div>
                          </div>
                        </div>
                        <div class="map-tooltip-section alt">
                          <div class="map-tooltip-labels">
                            <div class="map-tooltip-label alt">Subscription Type</div>
                            <div class="map-tooltip-value alt">Silent Guardian PRO</div>
                          </div>
                        </div>
                      </div>

                      <div
                        style="width: 95%; height: 100%; padding: 16px; background: var(--interactive-background-opacity-selected-contrast, rgba(103, 111, 115, 0.08)); border-bottom-right-radius: 4px; border-bottom-left-radius: 4px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px; display: inline-flex">
                        <div
                          style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 7px; display: inline-flex">
                          <div
                            [ngStyle]="{'background': item.alarm_Severity==1 ? '#FF4B38' : (item.alarm_Severity==2 ? '#FFD100' : 'var(--interactive-background-pressed, #363D40)')}"
                            style="width: 32px; height: 32px; border-radius: 20px; flex-direction: column; justify-content: center; align-items: center; gap: 10px; display: inline-flex">
                            <qds-icon  icon-library="default" name="bell-waves" [title]="item.alarm_Severity==1 ? 'Critical Alarm' : (item.alarm_Severity==2 ? 'Warning Alarm' : 'No Active Alarm')" size="large"
                              [ngClass]="item.alarm_Severity==1 || item.alarm_Severity==2 ? 'alarm-icon-dark' : 'qds-icon'"></qds-icon>
                          </div>


                          <div class="deviceStatus" [ngClass]="item.deviceStatus === 0 ? 'deviceStatus-offline' : (item.deviceStatus === 1? 'deviceStatus-online' :'deviceStatus-inactive')">
                              <qds-icon size="large" class="qds-icon" icon-library="default" name="link" [title]="item.deviceStatus === 0 ? labels.offline : (item.deviceStatus === 1 ? labels.online : labels.tableDataDeviceInActive)"></qds-icon>
                              <qds-tooltip text="online"></qds-tooltip>
                          </div>

                          <div *ngIf="item?.assignedInstallerId && role === roles.enduser"
                            class="assigned-installer">
                            <div class="assigned-installer-icon">
                              <qds-icon size="large" class="qds-icon" icon-library="default" name="person-gear"
                                [title]="item?.assignedInstallerEmail" style="left: 0.5625rem; top: 0.5rem; position: absolute;"></qds-icon>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- <qds-button size="small" importance="subdued" state="default" class="toolbar_icon map-tooltip-bell" icon-name="bell-waves"></qds-button> -->
                  <!-- <qds-button size="small" importance="subdued" state="default" class="toolbar_icon map-tooltip-dots" icon-name="dots-3-vertical"></qds-button> -->
                </div>
              </div>
            </div>
          </p-accordionTab>

          
        </p-accordion>
      </div>
      <div style="width: 70%; display: inline-block; left: 2px; height: 468px; position: relative;">
        <leaflet-map></leaflet-map>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedView === 'table'">
      <app-dashboard-table-view [groupedByDeviceGroups]="groupedByDeviceGroups"></app-dashboard-table-view>
      <div class="coming-soon-container">
        <div class="coming-soon-content">
          <qds-icon name="arrow-circular-clockwise-clock" class="coming-soon-icon"></qds-icon>
          <h2 class="coming-soon-title">Table View Coming Soon</h2>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedView === 'dock'">
      <app-dashboard-card-view [groupedByDeviceGroups]="groupedByDeviceGroups"></app-dashboard-card-view>
      <div class="coming-soon-container">
        <div class="coming-soon-content">
          <qds-icon name="arrow-circular-clockwise-clock" class="coming-soon-icon"></qds-icon>
          <h2 class="coming-soon-title">Card View Coming Soon</h2>
          <!-- <p class="coming-soon-text">This feature is under development</p> -->
        </div>
      </div>
    </ng-container>
  </div>
</div>